export enum VendorDenialReason {
    ViolatingTOS = "Violation of TOS (Terms of Service)",
    InvalidPayment = "Invalid Payment",
    InvalidPhoneNumber = "Invalid Phone Number",
    InappropriateWords = "Inappropriate Words in Name or Email",
    Other = "Other",
}